var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveryone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 75,
    viewBox: "0 0 95 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7128 73.0002C31.1178 73.0002 39.5527 64.5653 39.5527 54.1603C39.5527 43.7553 31.1178 35.3203 20.7128 35.3203C10.3077 35.3203 1.8728 43.7553 1.8728 54.1603C1.8728 64.5653 10.3077 73.0002 20.7128 73.0002Z",
    stroke: "#005A44",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2872 72.9983C84.6922 72.9983 93.1272 64.5633 93.1272 54.1583C93.1272 43.7533 84.6922 35.3184 74.2872 35.3184C63.8822 35.3184 55.4473 43.7533 55.4473 54.1583C55.4473 64.5633 63.8822 72.9983 74.2872 72.9983Z",
    stroke: "#005A44",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5553 24.8078C72.5553 24.8078 56.9479 20.9417 67.5583 36.2154",
    stroke: "#005A44",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0808 19.5655C54.0808 8.75747 53.512 0 49.2678 0C41.5833 0 37.4482 9.04358 37.4482 19.8516C37.4482 19.8516 36.7601 40.0984 46.5088 58.8361C47.1049 59.984 49.6527 60.8867 50.1262 59.6843C57.3032 41.4643 54.0774 19.5655 54.0774 19.5655H54.0808Z",
    fill: "#005A44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9526 19.5655C56.9526 8.75747 53.5123 0 49.2715 0C45.0307 0 41.5904 8.76087 41.5904 19.5655C41.5904 19.5655 41.2361 41.4608 48.4131 59.6843C48.8866 60.8867 49.6564 60.8867 50.1333 59.6843C57.3102 41.4643 56.956 19.5655 56.956 19.5655H56.9526Z",
    fill: "#2AC682"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.18 34.3681C53.5372 34.3681 55.448 28.7759 55.448 21.8774C55.448 14.979 53.5372 9.38672 51.18 9.38672C48.8229 9.38672 46.912 14.979 46.912 21.8774C46.912 28.7759 48.8229 34.3681 51.18 34.3681Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.394 19.8516C51.7796 19.8516 52.0923 18.9671 52.0923 17.876C52.0923 16.7849 51.7796 15.9004 51.394 15.9004C51.0083 15.9004 50.6957 16.7849 50.6957 17.876C50.6957 18.9671 51.0083 19.8516 51.394 19.8516Z",
    fill: "#005A44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2419 19.8516C54.4827 19.8516 54.6779 18.9671 54.6779 17.876C54.6779 16.7849 54.4827 15.9004 54.2419 15.9004C54.0011 15.9004 53.8059 16.7849 53.8059 17.876C53.8059 18.9671 54.0011 19.8516 54.2419 19.8516Z",
    fill: "#005A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveryone);
export default __webpack_public_path__ + "static/media/everyone.79a7d0ea952eaedfc166e4ac96cb89e5.svg";
export { ForwardRef as ReactComponent };